import qs from 'qs';
import axios from 'axios';
import { call } from 'redux-saga/effects';
import {
    GET_ALL_NEWS_ENDPOINT,
    GET_LAST_NEWS_ENDPOINT,
    GET_LAST_NEWS_FROM_ALL_CATEGORIES_ENDPOINT,
    GET_NEWS_DETAILS_ENDPOINT,
    GET_FAVORITE_NEWS_ENDPOINT,
    ADD_NEWS_TO_FAVORITE_ENDPOINT,
    ADD_NEWS_COMMENT,
    REMOVE_NEWS_FROM_FAVORITE_ENDPOINT, GET_SLIDER_NEWS_ENDPOINT, 
    GET_NEWS_FROM_CATEGORY_ENDPOINT, 
    GET_RECOMMENEDED_NEWS_ENDPOINT,
    GET_NEWS_CATEGORIES_ENDPOINT
} from '../config/apiEndpoints';
import { getTokenHeaders as tokenHeader } from '../helpers/api.helper';

export function* getAllNews(payload) {
    const header = tokenHeader();
    return yield call(axios.get, GET_ALL_NEWS_ENDPOINT, qs.stringify(payload), header);
}

export function* getSliderNews(payload) {
    const header = tokenHeader();
    return yield call(axios.get, GET_SLIDER_NEWS_ENDPOINT, qs.stringify(payload), header);
}


export function* getLastNews(payload) {
    const header = tokenHeader();
    return yield call(axios.get, GET_LAST_NEWS_ENDPOINT, header);
}

export function* getLastNewsFromAllCategories(payload) {
    const header = tokenHeader();
    return yield call(axios.get, GET_LAST_NEWS_FROM_ALL_CATEGORIES_ENDPOINT, qs.stringify(payload), header);
}

export function* getNewsDetails(payload){
    const header = tokenHeader();
    return yield call(axios.get, GET_NEWS_DETAILS_ENDPOINT + payload + "?_format=api_json", header);
}

export function* getFavoriteNews(payload){
    const header = tokenHeader();
    return yield call(axios.get, GET_FAVORITE_NEWS_ENDPOINT + window.localStorage.getItem('user_id'), header);
}

export function* addNewsToFavorite(payload){
    const header = tokenHeader();
    const body = {
        data: {
            type: "favourite_article--favourite_article",
            relationships: {
                article: {
                    data: {
                        type: "node--article",
                        id: payload
                    }
                }
            }
        }
    }

    return yield call(axios.post, ADD_NEWS_TO_FAVORITE_ENDPOINT, body, header);
}

export function* addNewsComment(payload){
    const header = tokenHeader();
    return yield call(axios.post, ADD_NEWS_COMMENT, payload, header)
}

export function* removeNewsFromFavorite(payload){
    const header = tokenHeader();
    return yield call(axios.delete, REMOVE_NEWS_FROM_FAVORITE_ENDPOINT + payload, header);
}

export function* getNewsFromCategory(payload){
    const header = tokenHeader();
    const url = GET_NEWS_FROM_CATEGORY_ENDPOINT + payload.id + "?_format=api_json&items_per_page=9&page=" + payload.page
    return yield call(axios.get, url, header);
} 

export function* getRecommendedNews(payload){
    const header = tokenHeader();
    return yield call(axios.get, GET_RECOMMENEDED_NEWS_ENDPOINT + '/' + payload +  "?_format=api_json&items_per_page=4", header);
}

export function* getNewsCategories(payload) {
    const header = tokenHeader();
    return yield call(axios.get, GET_NEWS_CATEGORIES_ENDPOINT, header);
}


// WEBPACK FOOTER //
// ./src/SHARED/api/news.api.js